import { useEffect, useRef, useState } from "react";
import RQuill from "../components/quill_editor";
import { Buffer } from "buffer";
import { useNavigate } from "react-router-dom";
import {
	Card,
	Input,
	Button,
	Typography,
	Row,
	Col,
	Form,
	message,
} from "antd";
import {
	EditOutlined,
	LeftCircleOutlined,
} from "@ant-design/icons";
import useFetch from "../_fetch";
import { Loader } from "../components/loader";
import { useSelector } from "react-redux";
import { query_type, user_role } from "../consts";
import SubQueryModal from "../components/SubQueryModal";
import moment from "moment";
import { useGetAllClients, useGetAllFinancialYears } from "../utils/queryUtils";

var QuillDeltaToHtmlConverter =
	require("quill-delta-to-html").QuillDeltaToHtmlConverter;

export default function CopyQuery(props) {
	const quillContent = useRef({ content: {}, html: "" });
	const [query, setQuery] = useState({});
	const displayDesc = useRef();
	const [loading, setLoading] = useState(true);
	const [, setComments] = useState([]);
	const [, setSubQueries] = useState([]);
	const [addQuery, setAddQuery] = useState(false);
	const [editQuery, setEditQuery] = useState(false);
	const [parentModalQueryId, setParentModalQueryId] = useState(null);
	const { role } = useSelector((st) => st.user);
	const clientsdatawithpagination = useGetAllClients();
	const client = clientsdatawithpagination?.data?.response;
	const { data: fy } = useGetAllFinancialYears();
	let [query_id, setQueryId] = useState('');
	const navigate = useNavigate();

	const _fetch = useFetch();
	const [form] = Form.useForm();
	useEffect(() => {
		if (props.query_id_value) {
			setQueryId(props.query_id_value);
		}
	}, [])
	let { setModalQueryId } = props;

	const init = async () => {

		try {
			let res = await _fetch(
				`${process.env.REACT_APP_API_URL}/query/${query_id}`
			);
			let result = await res.json();
			if (res.status === 200) {
				result.descriptionV2 = result.descriptionV2.map(dv2 => !("insert" in dv2) ? ({ insert: "", ...dv2 }) : dv2)
				setQuery(result);
				if (result) {
					var converter = new QuillDeltaToHtmlConverter(
						result.descriptionV2,
						[]
					);
					displayDesc.current = converter.convert();
				} else displayDesc.current = result.description;


				let commRes = await _fetch(
					`${process.env.REACT_APP_API_URL}/comment?query=${result?._id}`
				);
				if (commRes.status === 200) {
					commRes = await commRes.json();
					setComments(commRes.result);
				}
				await loadSubQueries();
			}
		} catch (e) {
			console.error(e);
		} finally {
			setLoading(false);
		}
	};

	const loadSubQueries = async () => {
		try {
			let res = await _fetch(
				`${process.env.REACT_APP_API_URL}/query/${query_id}?sub=true`
			);
			let result = await res.json();
			let commentData = [];
			for (let i = 0; i < result.length; i++) {
				let commRes = await _fetch(
					`${process.env.REACT_APP_API_URL}/comment?query=${result[i]._id}`
				);
				if (commRes.status === 200) {
					commRes = await commRes.json();
					result[i] = { ...result[i], comments: commRes?.result?.slice(0, 2), key: i };
				}
			}
			setSubQueries(result);
		} catch (e) {
		}
	};

	useEffect(() => {
		init();
	}, [query_id]);


	async function uploadPhotos(op) {
		let url = await _fetch(
			`${process.env.REACT_APP_API_URL}/file/get_upload_url?name=${query_id}_${moment().format("MMDDYYYYhhmmss")}.jpeg&query=${query._id}`
		);
		if (url.status === 200) {
			url = await url.json();
		} else {
			throw new Error("url to upload generation failed");
		}

		var buf = new Buffer.from(
			op.insert.image.replace(/^data:image\/\w+;base64,/, ""),
			"base64"
		);
		const options = {
			method: "PUT",
			headers: {
				"Content-Type": "image/jpeg",
			},
			body: buf,
		};
		let res = await fetch(url, options);
		if (res.status === 200) {
			try {
				let parsedUrl = new URL(url);
				let pathname = parsedUrl.pathname.slice(1);
				let fileInDB = await _fetch(`${process.env.REACT_APP_API_URL}/file`, {
					method: "POST",
					body: {
						query: query._id,
						path: pathname,
						type: "image/jpeg",
					},
				});
				if (fileInDB.status >= 200 && fileInDB.status < 300) {
					fileInDB = await fileInDB.json();
					op.insert.image = `${process.env.REACT_APP_API_URL}/file/get_object?id=${fileInDB._id}`;
					return op;
				}
			} catch (e) {
				console.error(e);
				return {};
			}
		}
		return {};
	}

	const handleQueryUpdate = async (update) => {
		if (!update.isOuterQuery) {
			let body = update;
			let { ops } = quillContent.current.content;
			if (ops) {
				let descriptionV2 = [];
				for (let i = 0; i < ops.length; i++) {
					if (ops[i].insert.image && !ops[i].insert.image.includes("http")) {
						let j = await uploadPhotos(ops[i]);
						descriptionV2.push(j);
					} else descriptionV2.push(ops[i]);
				}
				body = { ...body, descriptionV2, description: "" };
			}
			const userIds = props?.userIds;
			try {
				let res = await _fetch(`${process.env.REACT_APP_API_URL}/query/assign_primary_client`, {
					method: "POST",
					body: {
						queryId: props.query_id_value,
						userIds,
						title: body.title,
						descriptionV2: body?.descriptionV2
					}
				});
				let data = await res.json();
				if (data.success) {
					message.success("Primary client assigned successfully");
					props?.setCopyQueryApiFetch(true);
					props?.setCopyQueryModal(false);
				} else {
					message.error(data.message || 'Some error occurred while opening sub query');
					props?.setCopyQueryModal(false);
				}
				console.log("Saved:", userIds);
			} catch (err) {
				console.error("Save failed:", err);
			}

		} else {
			const userIds = props?.userIds;
			try {
				let res = await _fetch(`${process.env.REACT_APP_API_URL}/query/assign_primary_client`, {
					method: "POST",
					body: {
						queryId: props.query_id_value,
						userIds,
					}
				});
				let data = await res.json();
				if (data.success) {
					message.success("Primary client assigned successfully");
					props?.setCopyQueryApiFetch(true);
					props?.setCopyQueryModal(false);
				} else {
					message.error(data.message || 'Some error occurred while opening sub query');
					props?.setCopyQueryModal(false);
				}
				console.log("Saved:", userIds);
			} catch (err) {
				console.error("Save failed:", err);
			}
		}

	};

	const handleQuill = (content, delta, source, editor) => {

		quillContent.current.content = editor.getContents();
		quillContent.current.html = editor.getHTML();
	};

	function QueryForm() {
		return (
			<Form className="w-100" onFinish={handleQueryUpdate} form={form}>
				<div className="d-flex w-100 justify-content-between align-items-center">
					<Form.Item className="w-75" name="title" initialValue={query.title}>
						<Input
							value={query.title}
							size="large"
							autoFocus
							variant="borderless"
							style={{
								fontSize: "30px",
								border: 0,
							}}
						/>
					</Form.Item>
					<Form.Item>
						<Button
							onClick={() => setEditQuery(false)}
							size="large"
							style={{ fontSize: "12px", marginRight: "10px" }}
						>
							Cancel
						</Button>
						<Button
							type="primary"
							htmlType="submit"
							size="large"
							style={{ fontSize: "12px" }}
						>
							Send Invite
						</Button>
					</Form.Item>
				</div>
				<div className="d-flex flex-column align-items-start my-4">
					<Typography.Title level={5}>Description</Typography.Title>
					<RQuill
						onChange={handleQuill}
						queryID={query._id}
						initValue={
							query.descriptionV2?.length
								? query.descriptionV2
								: query.description
						}
					/>
				</div>
			</Form>
		);
	}

	return (
		<>
			<Card
				className="header-solid h-full mb-24"
				variant="borderless"
				style={{ body: { height: "100%", marginBottom: "24px" } }}
			>
				{loading ? (
					<Loader />
				) : query_id ? (
					<Row gutter={[10, 10]} className="h-100">
						<Col span={24}>
							<div className="p-2 h-auto">
								{editQuery ? (
									<QueryForm />
								) : (
									<div>
										{
											setModalQueryId && (
												<div
													className="d-flex flex-row align-items-center justify-content-start"
												>
													<LeftCircleOutlined
														onClick={() => {
															if (parentModalQueryId) {
																setModalQueryId(parentModalQueryId)
																setParentModalQueryId(null)
															} else {
																setModalQueryId(null)
															}
														}}
														style={{
															fontSize: '25px',
															cursor: 'pointer',
															color: '#1890ff'
														}}
													/>
													<Typography.Text
														style={{
															marginLeft: '10px'
														}}
													>
														<b>Query ID:</b> {query_id}
													</Typography.Text>
												</div>
											)
										}
										<div className="d-flex w-100 justify-content-between align-items-center">
											<div
												className="d-flex flex-row align-items-center justify-content-start"
											>
												{
													!setModalQueryId && (
														<LeftCircleOutlined
															onClick={() => {
																navigate(-1);
															}}
															style={{
																fontSize: '25px',
																cursor: 'pointer',
																color: '#1890ff',
																marginRight: '10px'
															}}
														/>
													)
												}
												<Typography.Title level={2} className="my-auto">
													{query?.title}
												</Typography.Title>
											</div>
											<Row>
												{role !== user_role.COMPANY && (
													<>
														<Row
															style={{ alignItems: "center", cursor: "pointer" }}
															onClick={() => setEditQuery(true)}
														>
															<EditOutlined
																style={{
																	color: "#1890ff",
																	fontSize: "20px",
																	marginRight: "5px",
																}}
															/>
															Edit
														</Row>
														<Button
															type="primary"
															htmlType="submit"
															size="large"
															style={{ fontSize: "12px", marginLeft: "30px" }}
															onClick={() => {
																handleQueryUpdate({ isOuterQuery: true });
															}}
														>
															Send Invite
														</Button>
													</>
												)}
											</Row>
										</div>
										<div className="d-flex flex-column align-items-start my-4">
											<Typography.Title level={5}>Description</Typography.Title>
											<div
												dangerouslySetInnerHTML={{
													__html: displayDesc.current,
												}}
												style={{ whiteSpace: "pre-line" }}
											/>
										</div>
										{query?.type === query_type.TRANSACTIONAL && (
											<div className="d-flex flex-column align-items-start my-4">
												<Typography.Title level={5}>
													Transaction Details
												</Typography.Title>
												<Typography.Text>
													{`Cash In: ${query.cashIn?.value || 0} ${query.cashIn?.currency || ""
														}`}
												</Typography.Text>
												<Typography.Text>
													{`Cash Out: ${query.cashOut?.value || 0} ${query.cashOut?.currency || ""
														}`}
												</Typography.Text>
												<Typography.Text>
													{`Date: ${query.Date !== undefined ? moment(query.Date).format(
														"DD MMM YYYY"
													) : ""} `}
												</Typography.Text>
											</div>
										)}
									</div>
								)}
							</div>
						</Col>
					</Row>
				) : (
					<div className="py-3 px-3">
						<Typography.Title level={3}>
							The Query does not exist or you do not have access :/
						</Typography.Title>
					</div>
				)}
			</Card>
			<SubQueryModal
				visible={addQuery}
				setVisible={setAddQuery}
				onSuccess={loadSubQueries}
				query={query}
			/>
		</>
	);
}
